module.exports = __webpack_public_path__ + "static/media/37.71f523e0.jpg";